'use strict';

import controller from './datos-generales-resumen.controller';
import template from './datos-generales-resumen.html';

const DatosGenerales = {
  bindings:{
    proyecto: '=',
    modoVista: '<'
  },
  controller,
  template
};

export default DatosGenerales;



// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/datos-generales-extra/datos-generales-resumen.component.js